export default "__VITE_ASSET__2bf1fd5b__"